// extracted by mini-css-extract-plugin
export default {"header":"ValidatorCompact_header__Rndgo","vertical":"ValidatorCompact_vertical__UAByE","moniker":"ValidatorCompact_moniker__0-kSv","footer":"ValidatorCompact_footer__R-Y8M"};